/* eslint-disable max-len */
import * as Constants from './constants';

export const testRequest = filters => ({
  type: Constants.TEST_REQUEST,
  filters,
})
export const testSuccess = result => ({
  type: Constants.TEST_SUCCESS,
  result,
})
export const testError = error => ({
  type: Constants.TEST_ERROR,
  error,
})

export const deleteRequest = (id, filters) => ({
  type: Constants.DELETE_REQUEST,
  id,
  filters,
})
export const deleteSuccess = data => ({
  type: Constants.DELETE_SUCCESS,
  data,
})
export const deleteError = error => ({
  type: Constants.DELETE_ERROR,
  error,
})

export const visibilityRequest = (tests, id, visibility, filters) => ({
  type: Constants.VISIBILITY_REQUEST,
  tests,
  id,
  visibility,
  filters,
})
export const visibilitySuccess = data => ({
  type: Constants.VISIBILITY_SUCCESS,
  data,
})
export const visibilityError = error => ({
  type: Constants.VISIBILITY_ERROR,
  error,
})
